import React, { useMemo } from 'react';

import cx from 'classnames';
import { IS_ACCELERATED_CURRICULUM_FILTER } from 'constants/assignments';
import { useAcceleratedCurriculums, useCurriculums } from 'sdk';

import {
  GRADE_OPTIONS,
  LESSON_OPTIONS,
  UNIT_OPTIONS
} from 'utils/curricullums/mapper';

import styles from './styles.module.scss';

const TemplateFilters = ({ filters, setFilters, onClearSearch }) => {
  const useCurriculumsHook = useMemo(() => {
    if (filters.is_accelerated) {
      return useAcceleratedCurriculums;
    }
    return useCurriculums;
  }, [filters.is_accelerated]);

  const { data: curriculumsData, isLoading: isLoadingCurriculums } =
    useCurriculumsHook({
      parentId: null,
      getGrandchildren: false
    });

  const rootCurriculums = curriculumsData?.results || [];

  const handleToggleAccelerated = () => {
    setFilters((prev) => {
      const nextAccelerated = !prev.is_accelerated;
      localStorage.setItem(
        IS_ACCELERATED_CURRICULUM_FILTER,
        JSON.stringify(nextAccelerated)
      );

      return {
        ...prev,
        is_accelerated: nextAccelerated,
        // Clear all dropdown selections when toggling
        root: '',
        grade: '',
        unit: '',
        lesson: ''
      };
    });
  };

  const handleSelectChange = ({ key, value }) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      ...{ search: '' }
    }));

    onClearSearch();
  };

  return (
    <div className={styles.filterContainer}>
      {/* Accelerated Toggle */}
      <div className={styles.toggleRow} onClick={handleToggleAccelerated}>
        <div
          className={cx(styles.toggleSwitch, {
            [styles.active]: filters.is_accelerated
          })}
        >
          {filters.is_accelerated && <span className={styles.check}></span>}
        </div>
        <span className={styles.toggleLabel}>Accelerated</span>
      </div>

      <select
        className={styles.filterSelect}
        value={filters.root || ''}
        onChange={(e) =>
          handleSelectChange({ key: 'root', value: e.target.value })
        }
      >
        <option value="">Curriculum</option>
        {isLoadingCurriculums ? (
          <option value="" disabled>
            Loading...
          </option>
        ) : (
          rootCurriculums.map((curricullum) => (
            <option key={curricullum.id} value={curricullum.title}>
              {curricullum.title}
            </option>
          ))
        )}
      </select>

      <select
        className={styles.filterSelect}
        value={filters.grade ?? ''}
        onChange={(e) =>
          handleSelectChange({ key: 'grade', value: e.target.value })
        }
      >
        <option value="">Grade</option>
        {GRADE_OPTIONS.map((option) => (
          <option key={option.key} value={option.key}>
            {option.key}
          </option>
        ))}
      </select>

      <select
        className={styles.filterSelect}
        value={filters.unit || ''}
        onChange={(e) =>
          handleSelectChange({ key: 'unit', value: e.target.value })
        }
      >
        <option value="">Unit</option>
        {UNIT_OPTIONS.map((option) => (
          <option key={option.key} value={option.value}>
            {option.key}
          </option>
        ))}
      </select>

      <select
        className={styles.filterSelect}
        value={filters.lesson || ''}
        onChange={(e) =>
          handleSelectChange({ key: 'lesson', value: e.target.value })
        }
      >
        <option value="">Lesson</option>
        {LESSON_OPTIONS.map((option) => (
          <option key={option.key} value={option.value}>
            {option.key}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TemplateFilters;
